import {Action} from "redux-actions";
import {
    addCurrentUserAction,
    clearFollow,
    clearFollowItems,
    clearUserAction,
    commonCityAction,
    commonStateAction,
    receiveNewData,
    receiveShops,
    receiveSpecials,
    receiveStyles,
    receiveUser,
    receiveUserError,
    receiveUsers,
    receiveUserSave,
    requestDifferentItems,
    requestNewData,
    requestShops,
    requestSpecials,
    requestStyles,
    requestUsers,
    requestUserSave
} from "./actions";
import {combineReducers} from "redux";
import Meta from "../_data/models/Meta";

//reducers
const userReducer = combineReducers({
    userID,
    loadingTab,
    loadingUser,
    stateList,
    cityList,
    isSaving,
    styleLoad,
    likedStyleLoad,
    followModalTab,
    currentUserID,
    users,
    shops,
    specials,
    styles
});

export default userReducer;

function userID(state: number = null, action: Action<UserAction>) {
    switch (action.type) {
        case receiveUser.toString():
            return action.payload.userID;
        case clearUserAction.toString():
            return null;
    }
    return state;
}

function loadingUser(state: boolean = false, action: Action<UserAction>) {
    switch (action.type) {
        case requestNewData.toString():
            return true;
        case receiveNewData.toString():
        case receiveUserError.toString():
            return false;
    }
    return state;
}

function users(state: { ids: number[], meta: null, loading: null }, action: Action<UserAction>) {
    switch (action.type) {
        case receiveUsers.toString():
            const pl = action.payload;
            return {
                ids: [...state.ids, ...pl.userIDs],
                meta: pl.meta,
                loading: false
            };
        case requestUsers.toString():
            return {
                ids: state.ids,
                meta: state.meta,
                loading: true
            };
        case clearUserAction.toString():
        case clearFollow.toString():
        case clearFollowItems.toString():
        case receiveShops.toString():
            return {ids: [], meta: null, loading: null};
    }
    return !state ? {ids: [], meta: null, loading: null} : state;
}

function shops(state: { ids: number[], meta: null, loading: null }, action: Action<UserAction>) {
    switch (action.type) {
        case receiveShops.toString():
            const pl = action.payload;
            return {
                ids: [...state.ids, ...pl.shopIDs],
                meta: pl.meta,
                loading: false
            };
        case requestShops.toString():
            return {
                ids: state.ids,
                meta: state.meta,
                loading: true
            };
        case clearUserAction.toString():
        case clearFollow.toString():
        case clearFollowItems.toString():
        case receiveUsers.toString():
            return {ids: [], meta: null, loading: null};
    }
    return !state ? {ids: [], meta: null, loading: null} : state;
}

function styles(state: { ids: number[], meta: null }, action: Action<UserAction>) {
    switch (action.type) {
        case receiveStyles.toString():
            const pl = action.payload;
            return {
                ids: [...state.ids, ...pl.styleIDs],
                meta: pl.meta
            };
        case clearUserAction.toString():
        case requestSpecials.toString():
        case requestDifferentItems.toString():
            return {ids: [], meta: null};
    }
    return !state ? {ids: [], meta: null} : state;
}

function specials(state: { ids: number[], meta: null, loading: null }, action: Action<UserAction>) {
    switch (action.type) {
        case receiveSpecials.toString():
            const pl = action.payload;
            return {
                ids: [...state.ids, ...pl.specialIDs],
                meta: pl.meta,
                loading: false
            };
        case requestSpecials.toString():
            return {
                ids: state.ids,
                meta: state.meta,
                loading: true
            };
        case clearUserAction.toString():
        case requestStyles.toString():
        case requestDifferentItems.toString():
            return {ids: [], meta: null, loading: null};
    }
    return !state ? {ids: [], meta: null, loading: null} : state;
}

function styleLoad(state: boolean = false, action: Action<UserAction>) {
    switch (action.type) {
        case requestStyles.toString():
            return action.payload.tab === "style";
        case requestSpecials.toString():
            return false;
    }
    return state;
}

function likedStyleLoad(state: boolean = false, action: Action<UserAction>) {
    switch (action.type) {
        case requestStyles.toString():
            return action.payload.tab === "likedStyle";
        case requestSpecials.toString():
            return false;
    }
    return state;
}

function loadingTab(state: boolean = false, action: Action<UserAction>) {
    switch (action.type) {
        case requestStyles.toString():
        case requestSpecials.toString():
            return true;
        case receiveStyles.toString():
        case receiveSpecials.toString():
            return false;
    }
    return state;
}

function followModalTab(state: boolean = false, action: Action<UserAction>) {
    switch (action.type) {
        case requestUsers.toString():
            return true;
        case requestShops.toString():
            return false;
    }
    return state;
}

function currentUserID(state: number = null, action: Action<DataAction>) {
    if (action.type == addCurrentUserAction.toString())
        return action.payload.id;

    return state;
}

function stateList(state: String[] = [], action: Action<UserAction>) {
    switch (action.type) {
        case commonStateAction.toString():
            return action.payload.stateList;
    }
    return state;
}

function cityList(state: String[] = [], action: Action<UserAction>) {
    switch (action.type) {
        case commonCityAction.toString():
            return action.payload.cityList;
    }
    return state;
}

function isSaving(state: boolean = false, action: Action<UserAction>) {
    switch (action.type) {
        case requestUserSave.toString():
            return true;
        case receiveUserSave.toString():
            return false;
    }
    return state;
}

//interfaces
interface UserAction {
    followed_id: number;
    is_followed: boolean;
    stateList: String[];
    cityList: String[];
    meta: Meta;
    userID: number;
    userIDs: number[];
    shopIDs: number[];
    specialIDs: number[];
    styleIDs: number[];
    tab: String;
    loading: boolean;
}

//interfaces
interface DataAction {
    id: number;
}


// WEBPACK FOOTER //
// ./app/client/user/reducers.ts